// Global Instructions Rule Applied!

/**
 * Read the download name out of a Content-Disposition header.
 *
 * Shared by every binary download (Excel export, document reports) so the
 * parsing rule lives in one place.
 *
 * Prefers RFC 5987 `filename*`, which is the only parameter allowed to carry
 * non-ASCII — the plain `filename=` sent alongside it is an ASCII-degraded
 * copy for older clients, so reading that one first would turn a fund called
 * Zürich into `Z_rich`.
 *
 * Note this header is unreadable cross-origin unless the response also sends
 * `Access-Control-Expose-Headers: Content-Disposition`. Without it the browser
 * hands back null and the caller silently falls back — which looks like the
 * server never set a name.
 */
export function filenameFromContentDisposition(
  disposition: string | null,
  fallback: string
): string {
  if (!disposition) return fallback

  const encoded = disposition.match(/filename\*=UTF-8''([^;]+)/i)?.[1]
  if (encoded) {
    try {
      return decodeURIComponent(encoded)
    } catch {
      // Malformed percent-encoding — fall through to the plain parameter.
    }
  }

  return disposition.match(/filename="?([^";]+)"?/i)?.[1] || fallback
}
